import type { ChildProps } from 'types'
import HotKeyProvider from './HotKeyProvider'

export default function HIDProviders({ children }: ChildProps): JSX.Element {
  return <HotKeyProvider>{children}</HotKeyProvider>
}
